import type { ReactNode } from 'react';
import extraWideJpeg from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-extra-wide.jpg';
import extraWideWebp from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-extra-wide.webp';
import narrowJpeg from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-narrow.jpg';
import narrowWebp from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-narrow.webp';
import wideJpeg from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-wide.jpg';
import wideWebp from 'images/promotions/viinitie/viinitie-banner-corporate-desktop-wide.webp';
import mobileJpeg from 'images/promotions/viinitie/viinitie-banner-corporate-mobile.jpg';
import mobileWebp from 'images/promotions/viinitie/viinitie-banner-corporate-mobile.webp';
import { BannerWrapper } from 'search/components/searchResults/ViinitieBanner';
import styles from 'search/components/searchResults/ViinitieBanner.module.scss';

const linkUrl = 'https://www.viinitie.fi/pages/b2b-asiakkaaksi';

export function CorporateBanner(props: { onClick?: () => void }): ReactNode {
  return (
    <BannerWrapper linkUrl={linkUrl} onClick={props.onClick}>
      <picture className={styles.content}>
        <source
          type="image/webp"
          srcSet={extraWideWebp}
          media="(min-width: 1921px)"
        />
        <source
          type="image/jpeg"
          srcSet={extraWideJpeg}
          media="(min-width: 1921px)"
        />
        <source
          type="image/webp"
          srcSet={wideWebp}
          media="(min-width: 1441px)"
        />
        <source
          type="image/jpeg"
          srcSet={wideJpeg}
          media="(min-width: 1441px)"
        />
        <source
          type="image/webp"
          srcSet={narrowWebp}
          media="(min-width: 641px)"
        />
        <source
          type="image/jpeg"
          srcSet={narrowJpeg}
          media="(min-width: 641px)"
        />
        <source
          type="image/webp"
          srcSet={mobileWebp}
          media="(max-width: 640px)"
        />
        <source
          type="image/jpeg"
          srcSet={mobileJpeg}
          media="(max-width: 640px)"
        />
        <img
          src={mobileJpeg}
          alt="Mainos – Viinitie Oy: Viinit yritystilaisuuteen. Lue Master of Winen osuvimmat viinisuositukset sesonkiin ja ota muistilista talteen!"
          decoding="async"
        />
      </picture>
    </BannerWrapper>
  );
}
